import React from "react";
import {
  Dialog,
  DialogContent,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
// import { trackEvent } from "../analytics/gtagHelper";

interface FullScreenDialogProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  url: string;
}

const FullScreenDialog: React.FC<FullScreenDialogProps> = ({
  isOpen,
  setIsOpen,
  url,
}) => {
  const isDesktop = useMediaQuery("(min-width: 768px)");
  const { t } = useTranslation();

  const handleClose = (
    _event?: object,
    reason?: "backdropClick" | "escapeKeyDown" | "iconClick"
  ) => {
    try {
      // trackEvent("privacyDialogClose", {
      //   category: "Dialog",
      //   reason,
      //   url,
      // });
    } catch {}
    setIsOpen(false);
  };

  return (
    <Dialog open={isOpen} onClose={handleClose} fullScreen={!isDesktop}>
      <IconButton
        aria-label={t("browseDialog.closeAria")}
        onClick={() => setIsOpen(false)}
        sx={{
          position: "absolute",
          right: 20,
          top: 20,
          backgroundColor: "black",
          color: "white",
          "&:hover": {
            color: "black",
            transition: "0.2s",
          },
          zIndex: 1,
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent
        sx={{
          padding: 0,
          height: "100%",
          ...(isDesktop && { width: "450px", height: "100vh" }),
        }}
      >
        <iframe
          src={url}
          className="w-full h-full"
          title={t("browseDialog.iframeTitle")}
        />
      </DialogContent>
    </Dialog>
  );
};

export default FullScreenDialog;
